import {
  appOrganizationPath,
  appProjectsPath,
  appSessionPath,
  appThreadPath,
} from '@/utils/constants';

export function getThreadUrl(
  organizationId: string | null,
  sessionId: string | undefined,
  conversationId: string
) {
  // see if encodeURI and encodeURIComponent returns same string.
  // If they do, we are sure there's no special characters decodeURI can't handle and use original path,
  // otherwise use searchParam instead.
  const uriEscaped = encodeURI(conversationId);
  const uriComponentEscaped = encodeURIComponent(conversationId);

  const prefix = `/${appOrganizationPath}/${organizationId}/${appProjectsPath}/${appSessionPath}/${sessionId}/${appThreadPath}`;
  if (uriEscaped === uriComponentEscaped) {
    return `${prefix}/${uriEscaped}`;
  }
  return `${prefix}/?conversationId=${uriComponentEscaped}`;
}
